import { userService } from "../services";
import config from "../config/config";

export const RouteAction = {
  fetchRouteList,
  AddRoute,
  fetchById,
  userActiveInactive,
  updateUser,
  deleteRoute,
};

async function fetchRouteList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.RouteList}?companyId=${payload.companyId}&pageSize=${payload.pageSize}&pageNo=${payload.pageNo}&destination=${payload.destination}&source=${payload.source}&name=${payload.name}&siteIds=${payload.siteIds}&userId=${payload.userId}`;
    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UpdateRoute}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function AddRoute(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddRoute}`;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ActiveRoute}`;
    // ?routeId=${payload.id}&status=${payload.status}&updatedBy=${payload.updatedBy}

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.RouteById}?routeId=${payload.Id}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function deleteRoute(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.routeDetele}?routeId=${payload.routeId}`;
    let response = await userService.deleteDetail(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
